import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Recruiter from "./Recruiter";

@Model()
class NetRecruiterPlacementFee extends ApplicationRecord {
  static jsonapiType = "net_recruiter_placement_fees";

  @Attr() totalFee: number;

  @BelongsTo(Recruiter) recruiter: Recruiter;
}

export default NetRecruiterPlacementFee;
